<template>
  <v-container
    fluid
    :class="'d-flex justify-space-between align-center'"
    :style="compact ? 'overflow-x: scroll' : ''"
  >
    <selection-sheet
      sheet-style="width: 100%; margin: 0.5rem 1rem"
      v-for="t of types"
      :key="t.id"
      :color="t.color"
      item-key="id"
      item-label="name"
      :item="t"
      :icon-key="t.icon"
      v-model="type"
      :small="compact"
      :fontSize="compact ? '0.7rem' : '1rem'"
    ></selection-sheet>
  </v-container>
</template>

<script>
import { FEATURES } from "../../_helpers/RestrictHelper";
import SelectionSheet from "../common/SelectionSheet.vue";

export default {
  name: "DeviceTypeSelect",

  components: { SelectionSheet },

  props: {
    inputType: { type: Number },
    compact: { type: Boolean, default: false },
    includeNone: { type: Boolean, default: false },
  },

  model: {
    prop: "inputType",
  },

  data() {
    let availableTypes = [
      {
        id: 0,
        name: "LoRaWAN",
        color: "primary",
        icon: "mdi-signal-variant",
      },
      {
        id: 1,
        name: "API",
        color: "orange",
        icon: "mdi-api",
      },

      {
        id: 2,
        name: "MQTT",
        color: "green",
        icon: "mdi-access-point",
      },

      {
        id: 3,
        name: "NodeRed",
        color: "red",
        icon: "mdi-nodejs",
      },

      {
        id: 4,
        name: "Sparkplug",
        color: "blue",
        icon: "mdi-shimmer",
      },

      {
        id: 5,
        name: "SpotIO",
        color: "teal",
        icon: "mdi-sitemap-outline",
      },

      {
        id: 6,
        name: "Modbus",
        color: "grey",
        icon: "mdi-format-list-numbered",
      },
    ];

    return {
      defaultTypes: availableTypes,
    };
  },

  computed: {
    type: {
      get() {
        return this.inputType;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    types() {
      // Slice here to get a copy of the array to not change the default value
      let tps = this.defaultTypes.slice(0, this.defaultTypes.length);

      // Add feature types here to only show the features if there enabled
      if (this.canAccessFeature(FEATURES.OPC))
        tps.push({
          id: 7,
          name: "OPC-UA",
          color: "cyan",
          icon: "mdi-ip",
        });

      if (this.includeNone)
        tps.push({
          id: null,
          name: "All",
          color: "grey",
          icon: "mdi-arrow-expand-all",
        });

      return tps;
    },
  },
};
</script>
